import type { PlanMode } from '../components/upgrade/upgrade-data';
import type { SkillEntitlementDecision } from './skills-api';

/** Which upgrade sheet an entitlement refusal should open, from its plan set. */
export function entitlementMode(
  decision: SkillEntitlementDecision | undefined,
): PlanMode | undefined {
  const set = decision?.recommendedPlanSet;
  if (set === 'employer') return 'employer';
  return set ? 'individual' : undefined;
}
